import { Box, Button, Typography } from "@mui/material";
import { useCreatePurchase } from "@mutations/useCreatePurchase";

export default function CreatePurchaseButton({ onCreated }: { onCreated: (uuid: string) => void }) {
  const { mutate, data, isPending, isError, isSuccess, error } = useCreatePurchase();

  const handleCreatePurchase = () => {
    const variables = {
      email: "john@example.com",
      firstName: "John",
      lastName: "Doe",
      organizationName: "Unyte",
      BIData: {
        source: "test-button",
      },
    };
    mutate(variables, {
      onSuccess: (res) => {
        onCreated(res.uuid || "");
      },
    });
  };

  return (
    <Box sx={{ p: "24px" }}>
      <Button onClick={handleCreatePurchase} variant="contained">
        {isPending ? "Creating..." : "Create Purchase"}
      </Button>

      {isSuccess && (
        <Typography sx={{ mt: "16px", color: "green" }}>
          ✅ Created! UUID: {JSON.stringify(data)}
        </Typography>
      )}

      {isError && (
        <Typography sx={{ mt: "16px", color: "red" }}>
          ❌ Error: {(error as Error).message}
        </Typography>
      )}
    </Box>
  );
}
